import { render, staticRenderFns } from "./SelectNum.vue?vue&type=template&id=489aae67&scoped=true&"
import script from "./SelectNum.vue?vue&type=script&lang=js&"
export * from "./SelectNum.vue?vue&type=script&lang=js&"
import style0 from "./SelectNum.vue?vue&type=style&index=0&id=489aae67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489aae67",
  null
  
)

export default component.exports